<template>
  <div class="modal_abandono">
    <b-modal
      :id="'modal_abandono'"
      :hide-header="true"
      v-model="modal"
      centered
      no-close-on-backdrop
    >
      <div class="d-flex justify-content-center">
        <img class="img" src="@/assets/icon_ballon.png" />
      </div>
      <div class="txt-header"><b>Opa, espere aí!</b></div>
      <div class="txt">
        Podemos te ajudar a encontrar o melhor plano <br />para você e sua
        família, me chame aqui no chat.
      </div>
      <template #modal-footer="{ cancel }">
        <div class="w-100 text-center">
          <b-button @click="abreAjuda" size="sm" class="ButtonSubmit"
            >Vamos conversar?</b-button
          >
          <b-button variant="link" @click="fechar(cancel)">
            Não, obrigado
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import store from '@/store/index'
export default {
  name: "ModalAbandonoPagina",

  mounted() {
    window.addEventListener("mouseout", this.myFunction);
  },

  data() {
    return { 
      modal: false,
      triedAbandono: false, };
  },

  methods: {
    myFunction(e) {
      var y = e.clientY;
      if (y < 10 && !store.getters.AliancaModalAbandono) {
        this.abreModal()
      }
    },
    abreModal(){
      if(!this.triedAbandono) this.modal = true;
      else return;
    },
    abreAjuda() {
      this.triedAbandono = true;
      this.$root.$emit('AbreFaleConosco')
      this.$bvModal.hide("modal_abandono");
      store.commit("mutAliancaModalAbandonoAtivado", true);
    },
    fechar(fnCancel) {
      fnCancel()
      window.removeEventListener("mouseout", this.myFunction)
      store.commit("mutAliancaModalAbandonoAtivado", true);
    },
  },
};
</script>